import { FC } from 'react';

import { SemanticAspectCard } from '@/components/SemanticAspectCard';
import { SemanticModelResult } from '@/hooks/dbtStrategy/useSemanticModel';

type SemanticModel = Omit<SemanticModelResult, 'applied'> | null;

interface MeasuresViewProps {
  resource: SemanticModel;
}

const useMeasures = (resource: SemanticModel) => {
  if (resource?.definition == null) return null;
  if (resource.definition.__typename !== 'SemanticModelDefinitionNode') return [];
  const measures = resource.definition.measures;
  return measures?.map((dimension) => ({
    name: dimension?.name ?? null,
    description: dimension?.description ?? null,
    type: dimension?.agg ?? null,
  }));
};

export const MeasuresView: FC<MeasuresViewProps> = ({ resource }) => {
  const measures = useMeasures(resource);

  if (measures == null) {
    return <div className="mt-10 text-fgDecorative">Loading...</div>;
  }

  if (!measures.length) {
    return <div className="mt-10 text-fgDecorative">No measures found.</div>;
  }

  return (
    <ul aria-label="Measures" className="mt-10 space-y-2">
      {measures.map((measure, index) => {
        return <SemanticAspectCard {...measure} key={measure?.name ?? `${index}`} />;
      })}
    </ul>
  );
};
